import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {
    playDigitalSound,
    playMusicalSound,
    playAlertSound,
    playZenSound,
    playPopSound,
    playCrystalSound
} from '../lib/soundUtils';

interface BoardHelpDialogProps {
  open: boolean;
  onClose: () => void;
}

const BoardHelpDialog: React.FC<BoardHelpDialogProps> = ({ open, onClose }) => {
    const soundSamples = [
        { name: 'アラート（規定設定）', func: playAlertSound },
        { name: 'デジタル', func: playDigitalSound },
        { name: 'ミュージカル', func: playMusicalSound },
        { name: 'ゼン（静か）', func: playZenSound },
        { name: 'ポップ', func: playPopSound },
        { name: 'クリスタル', func: playCrystalSound },
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: '16px' }
            }}
        >
            <DialogTitle sx={{ fontWeight: 800, borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                チャットボードの使い方
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <Box mb={3}>
                    <Typography variant="subtitle1" fontWeight={800} color="primary" gutterBottom>
                        公式LINEでのやり取り
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: '#334155' }}>
                        公式LINEでのやり取りは基本的にこちらで行います。<br />
                        公式LINE管理画面から直接送信したメッセージはこのチャットボードには（自動的には）表示されませんが、お客様からの返信は常に表示されます。
                    </Typography>
                </Box>

                <Box mb={3}>
                    <Typography variant="subtitle1" fontWeight={800} color="primary" gutterBottom>
                        サウンド通知
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: '#334155', mb: 2 }}>
                        新しいメッセージが届くと通知音が鳴ります。ブラウザの制限により、一度画面を操作（クリック等）しないと音が鳴らない場合があります。以下のボタンでサンプルを聴き比べ、動作確認を行ってください。
                    </Typography>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {soundSamples.map((sample, idx) => (
                            <Button
                                key={idx}
                                variant="outlined"
                                size="small"
                                onClick={() => sample.func()}
                                sx={{
                                    borderRadius: '8px',
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    fontSize: '12px'
                                }}
                            >
                                {sample.name}
                            </Button>
                        ))}
                    </Box>
                </Box>

                <Box mb={3}>
                    <Typography variant="subtitle1" fontWeight={800} color="primary" gutterBottom>
                        公式LINEと予約情報の紐付け
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: '#334155' }}>
                        今まで公式LINEのお客様のお名前を個別に変更していましたが、今後はこの画面で「お客様情報」と「公式LINE」を紐づけるようにしてください。<br />
                        紐付けることで、予約状況や顧客名が自動的に反映されます。
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="subtitle1" fontWeight={800} color="primary" gutterBottom>
                        一斉送信機能
                    </Typography>
                    <Typography variant="body2" sx={{ lineHeight: 1.7, color: '#334155' }}>
                        左端のチェックボックスで複数のユーザーを選択し、メッセージを一斉に送信できます。<br />
                        テンプレート作成や高度な条件分岐（if文など）の設定が難しい場合は、管理者までお問い合わせください。
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, borderTop: '1px solid #f1f5f9' }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{ borderRadius: '10px', px: 4, fontWeight: 800 }}
                >
                    閉じる
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BoardHelpDialog;
